module.exports = __webpack_public_path__ + "img/ABPIP-branca.3befcd68.png";